export default "__VITE_ASSET__RL4tYgKj__"